// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__LeLn1","buttonDisabled":"CustomButton_buttonDisabled__JlvvS","buttonNoShadow":"CustomButton_buttonNoShadow__SznZu"};